import React from "react"
import useEmployeeConditionAttributes from "components/employees/hooks/useEmployeeConditionAttributes"
import { Employee } from "types/Employee"
import { Stack } from "@chakra-ui/react"

export default function TestConfig({ employee }: { employee: Employee }): JSX.Element {
  const {
    data: employeeCondAttrs,
    isLoading: isLoadingEmplAttrs,
    error: getEmplAttrsError
  } = useEmployeeConditionAttributes(employee.employeeId)

  if (isLoadingEmplAttrs || getEmplAttrsError) {
    return null
  }
  return (
    <Stack>
      {Object.keys(employeeCondAttrs).map((key) => (
        <span key={key}>
          {key}:{employeeCondAttrs[key] ? "true" : "false"}
        </span>
      ))}
    </Stack>
  )
}
